export default "__VITE_ASSET__BMFmst3m__"